<template>
  <data-form
    :data="data"
    :formFields="formFields"
    @save="saveData"
    @cancel="cancel"
  />
</template>

<script>
import DataForm from "../widgets/DataForm.vue";
import VehicleReplacementTypeDataService from "../../services/vehicle-replacement-type.service";

export default {
  name: "vehicle-replacement-type-form",
  props: ["data"],
  components: {
    DataForm,
  },
  data() {
    return { message: "" };
  },
  computed: {
    formFields() {
      return {
        id: { type: "hidden" },
        name: { label: "Naziv", type: "text" },
        price_per_month: { label: "Cena po mesecu", type: "number", step: "0.01" },
      };
    },
  },
  methods: {
    saveData(newData) {
      if (newData && newData.id) {
        this.updateVehicleReplacementType(newData);
      } else {
        this.createVehicleReplacementType(newData);
      }
    },
    cancel() {
      this.$store.commit("app/hideModal");
    },
    updateVehicleReplacementType(newData) {
      VehicleReplacementTypeDataService.update(newData.id, newData)
        .then(() => {
          this.$store.commit("app/showAlert", {
            type: "success",
            message: "Tip zamene vozila je promenjen!",
          });
          this.$store.commit("app/hideModal");
        })
        .catch((e) => {
          this.$store.commit("app/showAlert", {
            type: "danger",
            message: e,
          });
        });
    },
    createVehicleReplacementType(newData) {
      VehicleReplacementTypeDataService.create(newData)
        .then(() => {
          this.$store.commit("app/showAlert", {
            type: "success",
            message: "Tip zamene vozila je kreiran!",
          });
          this.$store.commit("app/hideModal");
        })
        .catch((e) => {
          this.$store.commit("app/showAlert", {
            type: "danger",
            message: e,
          });
        });
    },
  },
};
</script>
